import React from 'react';
import { Paper, Box, Typography, Button, Slide } from '@mui/material';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

export default function ComparisonActionBar({ selectedCount, onCompare, onClear }) {
  return (
    <Slide direction="up" in={selectedCount > 0} mountOnEnter unmountOnExit>
      <Paper 
        elevation={4} 
        sx={{ 
          position: 'fixed', 
          bottom: 24, 
          left: '50%', 
          transform: 'translateX(-50%)',
          zIndex: (theme) => theme.zIndex.appBar,
          borderRadius: '16px',
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {selectedCount} selected
        </Typography>
        <Button 
          variant="contained" 
          onClick={onCompare} 
          disabled={selectedCount < 2 || selectedCount > 3}
          startIcon={<CompareArrowsIcon />}
        >
          Compare {selectedCount > 1 ? `(${selectedCount})` : ''}
        </Button>
        <Button variant="text" onClick={onClear}>
          Clear
        </Button>
      </Paper>
    </Slide>
  );
}
